import { render, staticRenderFns } from "./CommentType.vue?vue&type=template&id=138e64de&scoped=true&"
import script from "./CommentType.vue?vue&type=script&lang=js&"
export * from "./CommentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e64de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('138e64de')) {
      api.createRecord('138e64de', component.options)
    } else {
      api.reload('138e64de', component.options)
    }
    module.hot.accept("./CommentType.vue?vue&type=template&id=138e64de&scoped=true&", function () {
      api.rerender('138e64de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/timeline/partials/CommentType.vue"
export default component.exports